<template>
  <div class="apps">
    <EntityList
      v-bind:endpoint="'api/apps'"
      v-bind:filters="''"
      v-bind:entity="appEntity"
      v-bind:editAllowedFields="[]"
      v-bind:notDisplayedFields="['id']"
      v-bind:notShowEditAction="true"
      v-bind:notShowDeleteAction="true"
      v-bind:addLinkToDetails="true"
      v-bind:detailsRouterName="'featureintrodetails'"
      v-bind:defaultValues="{}"
      v-bind:title="'Apps'"
      v-bind:showNewItemBtn="false"/>
  </div>
</template>

<script>
import EntityList from './EntityList/EntityList.vue';
import AppEntity from '../store/entity/App';

export default {
  name: 'apps',
  components: { EntityList },
  data() {
    return {
      appEntity: AppEntity,
    };
  },
};
</script>

<style scoped>

</style>
